import React from "react"


export default function Spacer() {
  return   <div className={'Spacer'} style={{flexGrow: 1}}/>
}